<shared-badge
  *ngIf="source"
  [class]="classes"
  [label]="label"
  [tooltip]="tooltip"
>
</shared-badge>
